export const AdminContractManagerTypes = {
  SET_INITIAL_DATA: 'SET_INITIAL_DATA',
  SET_MODIFIED: 'SET_MODIFIED',
  ADD_ENTRY: 'ADD_ENTRY',
  CLEAR_MODIFIED: 'CLEAR_MODIFIED',
  SET_DELETED: 'SET_DELETED',
  SET_ADD: 'SET_ADD',
  SET_ENUMERATION: 'SET_ENUMERATION',
}
